import { Config } from '@mainstage/config';
import { MAX_HTTP_PAYLOAD_SIZE_MB } from './constants';

export function getSystemMaxHttpPayloadSizeMb(config: Config): number {
  return (
    config.getOptionalNumber('platform.httpPayloadSizeLimitMb') ??
    MAX_HTTP_PAYLOAD_SIZE_MB
  );
}
